/**
 * Maps business trip status to Polaris Badge tone.
 * Shared by business-trips and user-business-trips list views.
 */
export function getBusinessTripStatusTone(
  status: string
): "success" | "attention" | "critical" | undefined {
  const s = status || "draft";
  if (s === "completed" || s === "approved") return "success";
  if (s === "report_rejected" || s === "cancelled") return "critical";
  if (s === "pending_approval" || s === "pending_report" || s === "in_progress")
    return "attention";
  return undefined; // draft → default grey
}
